import React, { Component } from "react";
import TreeComponent from "../../common/tree/tree.component";
import "./course.tree.cmp.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileText, Video, TestTubeDiagonal } from "lucide-react";
import logoCoachSmall from "../../../assets/logo-coach-small.png";
import PLButton from "../../common/button";
import { withTranslation } from "react-i18next";

const treeStyles = {
  position: "relaive",
  top: 40,
  left: 40,
  color: "black",
  fill: "white",
  width: "100%",
  fontSize: "14px",
  // overflow:'auto'
};

class CourseTreeCmp extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = { selected: props.selected };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.setState({ selected: this.props.selected });
    }
  }

  onInternalSelect = (e, item) => {
    e.stopPropagation();
    this.setState({ selected: item });
    const { onSelect } = this.props;
    if (onSelect) onSelect(item);

    // Scroll containers to top when selecting new content
    setTimeout(() => {
      const playerWrapper = document.querySelector('.course-player-wrapper');
      const quizContainer = document.querySelector('.quiz-container');

      if (playerWrapper) {
        playerWrapper.scrollTo({ top: 0, behavior: "smooth" });
      }
      if (quizContainer) {
        quizContainer.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100);
  };

  getIcon = (type: string): any => {
    switch (type) {
      case "video":
        return "video";
      case "quiz":
        return "vial";
      case "course":
        return "book";
      case "module":
        return "book";
      case "resources":
        return "file-alt";
    }
  };

  // Helper function to clean up module titles
  cleanModuleTitle = (title: string, type: string) => {
    if (type === "module" && title) {
      // Remove "Module {number} -" pattern from the beginning (handles any number of digits)
      return title.replace(/^Module\s+\d+\s*[-–—]\s*/i, "").trim();
    }
    return title;
  };

  renderItem = (item) => {
    const { t } = this.props;
    const isSelected =
      this.state.selected && item && this.state.selected.id === item.id;
    const contentTypeClass = `content-type-${item.type}`;
    const displayTitle = this.cleanModuleTitle(item.title, item.type);

    return (
      <div
        key={item.id}
        className={`course-outline-container ${contentTypeClass} ${
          isSelected ? "course-outline-selected" : ""
        }`}
      >
        {/* Completion checkbox */}
        <div className="completion-checkbox">
          {this.isComplete(item) ? (
            <div className="completed-checkbox">
              <FontAwesomeIcon icon="check" className="completed-checkmark" />
            </div>
          ) : (
            <div className="uncompleted-square"></div>
          )}
        </div>

        {/* Content type icon - hide for modules */}
        {item.type !== "module" && (
          <div className="course-menu-button-container">
            {item.type === "video" && <Video size={19} />}
            {item.type === "quiz" && <TestTubeDiagonal size={17} />}
            {item.type === "resources" && <FileText size={17} />}
            {item.type === "course" && (
              <FontAwesomeIcon icon={this.getIcon(item.type)} />
            )}
          </div>
        )}

        {/* Content info */}
        <div className="course-info-container">
          <div className="course-outline-text-container">
            {item.type === "quiz"
              ? t("course.quiz")
              : item.type === "video"
              ? t("course.video")
              : displayTitle}
          </div>

          {/* Progress for courses */}
          {item.children && item.type === "course" && (
            <div className="course-progress-indicator">
              <span className="progress-fraction">
                {item.progress === 0
                  ? `0/${item.children.length}`
                  : `${Math.floor(
                      (item.progress * item.children.length) / 100
                    )}/${item.children.length}`}
              </span>
              <span>{t("course.lessons")}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderTree = (item) => {
    if (!item || !item.id) return <></>;
    const children = item.type === "quiz" ? null : item.children;

    // For root course item, only render children, not the course itself
    if (item.type === "course" && item.children) {
      return (
        <div key={`${item.id}-children`}>
          {item.children.map((childItem) => this.renderTree(childItem))}
        </div>
      );
    }

    return (
      <div key={item.id}>
        <TreeComponent
          className="table-tree"
          item={item}
          onSelect={(e) => this.onInternalSelect(e, item)}
          renderItem={this.renderItem}
          selected={this.state.selected ? this.state.selected == item : false}
          canDrag={false}
          dropable={false}
          completed={this.isComplete(item)}
          icon="file-alt"
          iconColor="green"
          style={treeStyles}
        >
          {children ? children.map((item) => this.renderTree(item)) : null}
        </TreeComponent>
      </div>
    );
  };

  isComplete = (item) => {
    if (item.type === "quiz") {
      return item.status === "pass";
    } else if (item.type === "resources") {
      return true;
    } else if (item.type === "module" && item.children) {
      // Module is complete if all its children are complete
      return item.children.every((child) => this.isComplete(child));
    } else {
      // For videos and other items, use the finish property
      return item.finish;
    }
  };

  render() {
    const { item, t } = this.props;
    return (
      <div
        className="main-class-editor outline-container"
        role="tree"
        aria-label={t("accessibility.courseOutline")}
      >
        <div className="course-section-header">
          <div className="course-header-content">
            <img
              src={logoCoachSmall}
              alt="CoachSafely"
              className="course-header-logo"
            />
            <div className="course-header-text">
              <div className="course-title">
                {t("course.courseName")}
              </div>
              <div className="course-title">{t("course.certification")}</div>
            </div>
          </div>
          <div className="course-header-dashboard">
            <PLButton onClick={(e) => this.onInternalSelect(e, item)}>
              {t("course.dashboard")}
            </PLButton>
          </div>
        </div>
        <div className="tree-content">{this.renderTree(item)}</div>
      </div>
    );
  }
}

export default withTranslation()(CourseTreeCmp);
